import axios from '@/api/config';

const orderInfo = {
    getOrderInfoById(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderInfo/` + data, {});
    },
    getOrderInfo(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderInfo`, { params: data });
    },
    getOrderInfoList(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderInfoList`, { params: data });
    },
    getOrderInfoTree(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderInfoTree`, { params: data });
    },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/pageList`, data);
    },
    addOrderInfo(data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/addOrderInfo`, data);
    },
    updateOrderInfo(data) {
        return axios.put(`${process.env.BASE_URL}/orderInfo/updateOrderInfo`, data);
    },

    deleteOrderInfo(data) {
        return axios.delete(`${process.env.BASE_URL}/orderInfo/deleteOrderInfo`, { data: data });
    },
    exportExcel(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/exportExcel`, { params: data });
    },
    getOrderSourceType(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderSourceType`, { params: data });
    },
    getOrderState(data) {
        return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderState`, { params: data });
    },
    getOrderListStats(data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/getOrderListStats`, data);
    },
    importData(data) {
        return axios.post(`${process.env.BASE_URL}/orderInfo/importData`, data);
    }
}

export default orderInfo;


// WEBPACK FOOTER //
// ./src/api/orderInfo.js